import get from 'lodash/get';
import moment from 'moment';
import ReactStars from 'react-stars';

import { customFieldWidgetTypes } from 'shared/constants';
import { copy } from 'shared/functions';

import SkillsSetPreview from './SkillsSetPreview';
import { TooltipWrapper } from './TooltipWrapper';

export const safeWrap = (Comp) => (props) => <Comp {...props} />;

export const getPatchedJsonSchema = (originalJsonSchema, uiSchema, fieldKeys) => {
  const fsemConfig = uiSchema['#fsemConfig'];
  const jsonSchema = copy(originalJsonSchema);

  const usedFieldKeys = fsemConfig ? fsemConfig.reduce((prev, cur) => [...prev, ...cur.fieldKeys], []) : [];
  jsonSchema.properties = Object.keys(jsonSchema.properties || {})
    .filter((jsonSchemaKey) => {
      if (fieldKeys) {
        return fieldKeys.includes(jsonSchemaKey);
      } else if (fsemConfig) {
        return !usedFieldKeys.includes(jsonSchemaKey);
      }
      return true;
    })
    .reduce(
      (prev, cur) => ({
        ...prev,
        [cur]: jsonSchema.properties[cur],
      }),
      {},
    );

  return jsonSchema;
};

export const getTransformedErrors = (uiSchema, errors) =>
  errors.map((error) => {
    if (error.name === 'maxItems' && typeof error.property === 'string') {
      if (uiSchema?.[error.property.substr(1)]?.['ui:widget'] === 'skillsTaxonomy') {
        error.message = `You are limited to ${error.params.limit} items`;
        error.stack = `${error.property} ${error.message}`;
      }
    }
    return error;
  });

export const getOrderedEntries = (value, order) =>
  Object.entries(value).sort(([left], [right]) => {
    if (!order.includes(left)) return 1;
    return order.indexOf(left) - order.indexOf(right);
  });

export const renderValue = (
  value,
  { dateFormat, schemaProperty, uiSchema, jsonSchemaKey, previewMode, showInline },
) => {
  const uiWidget = get(uiSchema, [jsonSchemaKey, 'ui:widget']);
  const className = showInline ? 'inline-block-div' : '';
  if (uiWidget === customFieldWidgetTypes.rte) {
    return <TooltipWrapper previewMode={previewMode} value={<span dangerouslySetInnerHTML={{ __html: value }} />} />;
  } else if (uiWidget === customFieldWidgetTypes.stars) {
    return (
      <ReactStars
        className={className}
        count={schemaProperty.maximum || 5}
        value={value}
        size={24}
        color2={'#ffd700'}
        half={false}
        edit={false}
      />
    );
  } else if (uiWidget === customFieldWidgetTypes.skillsTaxonomy) {
    return <SkillsSetPreview candidateCustomField={jsonSchemaKey} value={value} schemaProperty={schemaProperty} />;
  } else if (value && schemaProperty.type === 'string' && schemaProperty.format === 'date') {
    return moment(value).format(dateFormat);
  } else if (Array.isArray(value)) {
    if (value.every((item) => item && typeof item === 'object')) {
      const uiOrder = get(uiSchema, [jsonSchemaKey, 'items', 'ui:order'], []);
      return (
        <div
          className="array-item-value"
          dangerouslySetInnerHTML={{
            __html: value
              .map((item) =>
                getOrderedEntries(item, uiOrder)
                  .map(([, fieldValue]) => fieldValue)
                  .join('<hr class="dotted"/>'),
              )
              .join('<div class="value-separator"><div></div></div>'),
          }}
        />
      );
    }
    return value.join(', ');
  } else if (typeof value === 'boolean') {
    return <span>{`${value}`}</span>;
  }
  return <TooltipWrapper previewMode={previewMode} value={value} />;
};
